import { motion } from "framer-motion";
import { ArrowDown, Star } from "lucide-react";
import { MaskLine, Overline } from "@/components/motion";
import { CONTACT } from "@/data/site";

const Hero = ({ onBook }) => {
  return (
    <section className="relative min-h-screen pt-24 md:pt-28 pb-16 overflow-hidden">
      <div className="relative z-10 max-w-[1600px] mx-auto px-5 md:px-10">
        {/* Top row */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="flex items-center justify-between flex-wrap gap-4"
        >
          <Overline>16 Years in Service — {CONTACT.area}</Overline>
          <div className="flex items-center gap-2 text-sm font-medium" data-testid="hero-rating">
            <Star size={15} className="fill-foreground text-foreground" />
            {CONTACT.rating} · {CONTACT.reviews} Google reviews
          </div>
        </motion.div>

        {/* Headline */}
        <h1 className="mt-6 md:mt-8 font-serif font-light uppercase leading-[0.82] tracking-tighter text-foreground text-[13vw] md:text-[10vw] lg:text-[9vw]">
          <MaskLine delay={0.25}>Stainless</MaskLine>
        </h1>

        {/* Content — everything left-aligned */}
        <div className="mt-8 md:mt-10 max-w-2xl">
          <MaskLine delay={0.7}>
            <p className="font-serif text-3xl md:text-5xl font-light leading-[1.05] tracking-tight">
              Dry Cleaners of South Delhi.
            </p>
          </MaskLine>

          <p className="mt-5 text-base md:text-lg font-light text-foreground/80 leading-relaxed">
            Suits, sarees, leather, linens and everything you love — collected from your door,
            treated with obsessive care, and returned immaculate. Free pickup &amp; delivery across {CONTACT.area}.
          </p>

          {/* Buttons — left-aligned, 16px gap, stack full-width below 640px */}
          <div className="mt-8 flex flex-col sm:flex-row items-start gap-4">
            <button
              data-testid="hero-book-btn"
              onClick={onBook}
              className="group relative w-full sm:w-auto bg-foreground text-background px-8 py-4 text-sm font-medium uppercase tracking-widest overflow-hidden"
            >
              <span className="relative z-10 flex items-center justify-center gap-2 transition-colors duration-300 group-hover:text-foreground">
                Book a Pickup <ArrowDown size={16} className="-rotate-45" />
              </span>
              <span className="absolute inset-0 bg-background translate-y-full group-hover:translate-y-0 transition-transform duration-300" />
            </button>

            <button
              data-testid="hero-services-btn"
              onClick={() => document.getElementById("services")?.scrollIntoView({ behavior: "smooth" })}
              className="group relative w-full sm:w-auto border border-foreground bg-background/40 px-8 py-4 text-sm font-medium uppercase tracking-widest overflow-hidden text-foreground"
            >
              <span className="relative z-10 flex items-center justify-center transition-colors duration-300 group-hover:text-background">
                View Services
              </span>
              <span className="absolute inset-0 bg-foreground translate-y-full group-hover:translate-y-0 transition-transform duration-300" />
            </button>
          </div>

          {/* Trust line */}
          <p className="mt-5 text-sm font-light text-foreground/70">
            16 years in service · Free pickup &amp; delivery · Ready in 48 hours · Trusted across South Delhi
          </p>
        </div>
      </div>
    </section>
  );
};

export default Hero;
